import React from 'react';
import PropTypes from 'prop-types';
import { Button, HeadingText, Link } from '@paypalcorp/pp-react';
import ExtraInfo from './ExtraInfo';
import ImageButtons from './ImageButtons';
import { preventTabNabbing } from '../../../lib/helpers';

const DetailsText = props => {
  const {
    app,
    title,
    subtitle,
    direction,
    ctaText,
    ctaUrl,
    isLink,
    extraInfo,
    imageButtonValues,
    handleClickFPTI,
    handleClick,
    toolName,
    fptiLinkName
  } = props;
  const { context: { location: { domain } = {} } = {} } = app;
  return (
    <div
      className={`details-option-text ${
        direction === 'rtl'
          ? 'details-option-text-right'
          : 'details-option-text-left'
      }`}
    >
      <HeadingText level={2} className="align-left" dangerouslySetInnerHTML={{ __html: title }} />
      <div
        onClick={e =>
          e.target.tagName === 'A' && e.target.getAttribute('data-fptilinkname')
            ? handleClickFPTI(e.target.getAttribute('data-fptilinkname'))
            : {}
        }
        className="align-left"
        dangerouslySetInnerHTML={{ __html: subtitle }}
        role="presentation"
      ></div>
      <ExtraInfo extraInfo={extraInfo} />
      {isLink && ctaUrl && (
        <Link
          className={'align-left link-as-button'}
          rel={preventTabNabbing(ctaUrl, domain)}
          as="button"
          onClick={() => handleClick(ctaUrl, fptiLinkName)}
        >
          {ctaText}
        </Link>
      )}
      {!isLink && ctaUrl && (
        <Button secondary onClick={() => handleClick(ctaUrl, fptiLinkName)}>
          {ctaText}
        </Button>
      )}
      <div className="details-option-image-button-container">
        <ImageButtons
          imageButtons={imageButtonValues}
          handleClickFPTI={handleClickFPTI}
          toolName={toolName}
          app={app}
        />
      </div>
    </div>
  );
};

DetailsText.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  direction: PropTypes.string,
  ctaText: PropTypes.string,
  ctaUrl: PropTypes.string,
  isLink: PropTypes.bool,
  extraInfo: PropTypes.array,
  imageButtonValues: PropTypes.array,
  developerLink: PropTypes.object,
  handleClickFPTI: PropTypes.func,
  handleClick: PropTypes.func,
  addDevLink: PropTypes.func,
  toolName: PropTypes.string,
  fptiLinkName: PropTypes.string,
  app: PropTypes.object
};
export default DetailsText;
